import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";

export const Header = styled.header`
    display: flex;       
    gap: 40px;            
    margin-top: 20px;
    padding: 0 40px;
    font-family: Memphis !important;
    font-weight: bold;
    align-items: center; 
    font-size: 28px;

    @media (max-width: 768px) {
        padding: 0 20px;
        gap: 20px;
        font-size: 20px;
    }
`;

export const SymbolGroup = styled.div`
    display: flex;
    align-items: center; 
    gap: 15px;
    margin-left: auto;   
`;

export const SymbolLinkedin = styled.h3`
   display: flex;
    align-items: center;
    font-size: 26px;
    cursor: pointer;
    color: black;
    transition: transform 0.2s;
    &:hover {
        transform: scale(1.1); 
        color: #0077b5;
    }
`;

export const SymbolBehance = styled.h3`
   display: flex;
    align-items: center;
    font-size: 30px;
    cursor: pointer;
    color: black;
    transition: transform 0.2s;
    &:hover {
        transform: scale(1.1); 
        color: #D20A2D;
    }
`;

export const Footer = styled.footer`
    margin-top: auto;        
    background-color: #000; 
    display: flex;
    width: 100%;           
    padding: 40px;        
    align-items: flex-start; 
    justify-content: flex-start;
    gap: 60px; 
    box-sizing: border-box;
    min-height: 200px;
    color: #fff;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 30px;
        padding: 40px 20px;
    }
`;

export const Logo = styled.img`
    width: 50px;     
    height: auto;
    border-radius: 10px;
`;

export const BarraVertical = styled.div`
    background-color: #FFFFFF;
    width: 2px;          
    height: 100px;       
    border: none;       
    margin: 0 60px;    
    align-self: center;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const App = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction:column;
`;

export const AppAbout = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction:column;
    background-color: #000;
`;

export const MainContent = styled.main`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 40px;
    font-family: Memphis LT Pro !important;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 20px;
    }
`;


export const TitleGroup = styled.div`
    display: flex;
    flex-direction: column;
    font-family: 'Arial', sans-serif;
`;

export const DandeliousText = styled.h1`
    font-size: 96px;
    margin: 0;
    display: flex;
    font-family: Memphis LT Pro !important;
    align-items: center;
    gap: 10px;
    justify-content: center;

    @media (max-width: 768px) {
        font-size: 48px;
    }
`;

export const Automec = styled.h2`
  font-size: 96px;
  margin: 0;
  font-family: Memphis !important;
  display: block; 

  @media (max-width: 768px) {
      font-size: 48px;
  }
`;

export const AnimationDiv = styled.div`
    font-size: 96px;
    margin: 0;
    display: flex;
    font-family: Memphis LT Pro !important;
    align-items: center;
    gap: 10px;

    @media (max-width: 768px) {
        font-size: 48px;
    }
`;

export const FooterText = styled.h3`
    position: absolute;
    width: 282px;
    height: 102px;
    font-family: 'Memphis LT Pro';
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 48px;
    color: #FFFFFF;

    @media (max-width: 768px) {
        position: relative;
        font-size: 28px;
        width: auto;
        height: auto;
    }
`

const shakeAnimation = keyframes`
  0% { transform: translate(0, 0) rotate(0deg) scale(1.1); }
  20% { transform: translate(-3px, 0px) rotate(-1deg) scale(1.1); }
  40% { transform: translate(3px, 2px) rotate(1deg) scale(1.1); }
  60% { transform: translate(-3px, 1px) rotate(-1deg) scale(1.1); }
  80% { transform: translate(3px, -1px) rotate(1deg) scale(1.1); }
  100% { transform: translate(0, 0) rotate(0deg) scale(1.1); }
`;

export const MainLogo = styled.img` 
    cursor: pointer;
    &:hover {
        animation: ${shakeAnimation} 0.2s infinite linear;
    }
`;

export const AchilesLogo = styled.img`
    width: 300px; 
    height: auto;
    margin-left: auto; 

    @media (max-width: 768px) {
        margin-left: 0;
        width: 200px;
    }
`;

export const Divider = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 16px 0;
`;

export const Line = styled.div`
  flex: 1;
  height: 2px;
  background-color: black;
`;

export const ContactBox = styled.div`
    border: 1px solid #FFFFFF;
    display: flex;
    flex-direction: column;
    width: fit-content;
    min-width: 400px;

    @media (max-width: 768px) {
        min-width: 100%;
    }
`;

export const ContactHeader = styled.div`
    border-bottom: 1px solid #FFFFFF;
    padding: 10px 15px;
    font-family: 'Memphis LT Pro', sans-serif;
    font-weight: bold;
    font-size: 28px;
`;

export const ContactBody = styled.div`
    padding: 30px 15px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 22px;
    letter-spacing: 1px;

    @media (max-width: 768px) {
        font-size: 16px;
        word-break: break-all;
    }
`;
export const FooterNav = styled.nav`
    display: flex;
    flex-direction: column;
    gap: 15px;
    
    span, a {
        font-family: 'Memphis LT Pro';
        font-weight: bold;
        font-size: 24px;
        color: white;
        text-decoration: none;
        cursor: pointer;

        &:hover {
            opacity: 0.7;
        }
    }
`;

export const ProjectContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100px;
  height: 160px;
  position: relative;
`;


export const ProjectBox = styled(motion.div)`
  width: 100px;
  height: 100px;
  background-color: #0cdcf7;
  border-radius: 10px;
`;

export const ProjectButton = styled.button`
  border-radius: 10px;
  padding: 10px 20px;
  color: #0f1115;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border: none;
  cursor: pointer;
  
  &:hover {
    filter: brightness(1.1);
  }
`;

export const ProjectNumber = styled(motion.div)`
  font-size: 32px;
  font-weight: bold;
  color: #0000;
  font-family: 'Memphis LT Pro', sans-serif;
  cursor: pointer;
  &:hover {
    color: #FFD700;
  }
`;

export const HeroSection = styled.div`
    display: flex;
    flex-direction: ${props => props.isMobile ? 'column' : 'row'};
    align-items: center;
    justify-content: center;
    gap: 50px;
    width: 100%;
    min-height: 80vh;
`;

export const ProjectViewSection = styled(motion.div)`
    width: 100%;
    max-width: 1200px;
    margin: 40px 0;
    color: #000;
`;

export const Section = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 40px;
  margin-left: 40px;

  @media (max-width: 768px) {
      flex-direction: column;
      margin-left: 0;
      gap: 20px;
  }
`;

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
`;

export const TextoAbaixo = styled.p`
  font-size: 28px;
  line-height: 1.6;
  margin-top: 23px;
  font-family: Memphis;
  margin-right: auto;
  font-weight: 300px;

  @media (max-width: 768px) {
      font-size: 18px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-left: 40px;

  @media (max-width: 768px) {
      margin-left: 0;
  }
`;

export const ProjectLayout = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  max-width: 1400px; 
  margin: 0 auto;
  padding: 40px;

  @media (max-width: 768px) {
      flex-direction: column;
      padding: 0; /* Remove padding interno no mobile */
      width: 100%;
  }
  `;

export const TextContainer = styled.div`
  flex: 1;
  max-width: 600px; 
  display: flex;
  flex-direction: column;
  align-items: flex-start; 
  text-align: left;

  @media (max-width: 768px) {
      max-width: 100%; /* Garante que a lista use a largura toda */
      width: 100%;
  }
`;

export const ProjectImage = styled.img`
  max-width: 400px;
  height: auto;
  align-self: flex-end; 

  @media (max-width: 768px) {
      align-self: center;
      max-width: 100%; 
      margin-top: 20px;
      order: -1; /* Opcional: coloca a imagem acima da lista de arquivos no mobile */
  }
`;


export const BentoGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(4, 1fr); 
  grid-auto-rows: 220px; 
  gap: 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  overflow: visible;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    min-height: 200px;
  }
`;


export const BentoGridAbout = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 220px;
  gap: 20px;
  width: 100%;
  max-width: 500px;
  margin: 0;
  overflow: visible;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    max-width: 100%;
  }
`;

export const BentoItem = styled(motion.div)`
  background: #f5f5f7; 
  border-radius: 28px;
  overflow: hidden; 
  display: block;
  flex-direction: column;
  padding: 24px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  grid-column: ${props => (props.isLarge || props.isWide ? "span 2" : "span 1")};
  grid-row: ${props => (props.isLarge ? "span 2" : "span 1")};
  position: relative;
  object-fit: cover;
  z-index: 1;
  will-change: transform; 
  &:hover {
    z-index: 10;
  }

  @media (max-width: 768px) {
      grid-column: span 1 !important;
      grid-row: span 1 !important;
  }
`;


export const CardImage = styled(motion.img)`
  position: absolute;
  inset: 0; 
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

export const HeaderDivider = styled(motion.div)`
  width: 100%;
  height: 2px; 
  background: linear-gradient(90deg, #000 0%, #000 100%); 
  position: relative;
  margin-bottom: 20px; 
  transform-origin: left;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 70%;
    transform: translateY(-50%);
    width: 0; 
    height: 0; 
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 6px solid #000;
  }
`;

export const WhiteHeaderDivider = styled(motion.div)`
  width: 100%;
  height: 2px; 
  background: linear-gradient(90deg, #FFF 0%, #FFF 100%); 
  position: relative;
  margin-bottom: 20px; 
  transform-origin: left;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 70%;
    transform: translateY(-50%);
    width: 0; 
    height: 0; 
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 6px solid #FFF ;
  }
`;